import React from "react";
import Button from "../../base-components/button";
import utils from "./utils";
import classes from "./index.module.css";

const BuySuccess = () => {
  const onSubmit = () => {};

  return (
    <div className={classes.Container}>
      <div className={classes.top}></div>
      <div className={classes.middle}>
        <h2 className={classes.Heading}>{utils.BUY_SUCCESS_HEADER}</h2>
        <p className={classes.SubHeading}>{utils.BUY_SUCCESS_SUBHEADING}</p>
      </div>
      <div className={classes.bottom}>
        <Button
          //spacing={{ top: "medium", bottom: "medium" }}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={false}
          state={undefined}
          action={onSubmit}
        >
          {utils.BUY_SUCCESS_BUTTON_HEADING}
        </Button>
      </div>
    </div>
  );
};

export default BuySuccess;
